import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { FieldArray, formValueSelector } from 'redux-form'
// components
import { ReduxDatePicker } from 'components/FormElements/ReduxForm'
import renderReviewers from 'components/Modals/CreateScheduledReviewModal/components/Form/components/RenderReviewers'
// views
import InputLabel from 'components/FormElements/components/InputLabel'
// constants
import { Forms } from 'constants/index'
// utils
import { required } from 'utils/index'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;

  .date-picker-wrapper {
    width: 48%;
  }
`

const Container = styled.div`
  display: flex;
  gap: 16px;

  > div {
    flex: 1;
  }
`

// types
interface IIncomingProps {
  form?: string
  hideReviewers?: boolean
  chosenReviewersIds?: string[]
}

const SingleReviewForm: React.FunctionComponent<IIncomingProps> = ({
  form = Forms.SCHEDULE_REVIEW_FORM,
  hideReviewers,
  chosenReviewersIds
}) => {
  const selector = formValueSelector(form)

  const { startPeriod, endPeriod } = useSelector((state) => ({
    startPeriod: selector(state, `startPeriod`),
    endPeriod: selector(state, `endPeriod`)
  }))

  return (
    <Wrapper>
      <Container>
        <ReduxDatePicker
          label={'Start of reporting period'}
          name={'startPeriod'}
          validate={[required]}
          maxDate={endPeriod}
        />
        <ReduxDatePicker
          label={'End of reporting period'}
          name={'endPeriod'}
          validate={[required]}
          minDate={startPeriod}
        />
      </Container>
      {!hideReviewers && (
        <>
          <InputLabel>Specify reviewers and expected completion dates</InputLabel>
          <FieldArray
            name={'singleReviewReviewers'}
            component={renderReviewers as any}
            chosenReviewersIds={chosenReviewersIds}
          />
        </>
      )}
      <ReduxDatePicker
        label={'Expected completion date'}
        name={'completionDate'}
        validate={[required]}
        minDate={startPeriod}
      />
    </Wrapper>
  )
}

export default SingleReviewForm
